import script from "./SelectTheme.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectTheme.vue?vue&type=script&setup=true&lang=js"

import "./SelectTheme.vue?vue&type=style&index=0&id=6785387d&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6785387d"]])

export default __exports__